const ParseNumberToFloat = ({number, currency = "Soles", className = `${!number ? "text-gray-200" : "text-xs text-gray-900"}`}) => {

  if (!number) return "-"
  if (number === 0) return "0.00"

  return (
    <span className={className}>
      {currency === "Soles" ? "S/. " : "$ "}
      {number.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
    </span>
  )
}

export default ParseNumberToFloat